/************************************************************************************************
 * Copyright TRUSST AI PTY LTD. All Rights Reserved.                                            *
 *                                                                                              *
 * Licensed under the TRUSST SOFTWARE LICENSE (the "License"). You may not use this file except *
 * in compliance with the "LICENSE" file accompanying this file. This file is distributed       *
 * on an "AS IS" BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, express or implied.       *
 *                                                                                              *
 * See the "License" file for the specific language governing permissions and limitations       *
 * under the License and limitations under the License.                                         *
 ***********************************************************************************************/

export enum AGENTS_API_EVENT_NAMES {
  CloneAgent = 'CloneAgent',
  CreateRoom = 'CreateRoom',
  CreateTestContact = 'CreateTestContact',
  DeleteAgent = 'DeleteAgent',
  DeleteAgentTool = 'DeleteAgentTool',
  DeleteContact = 'DeleteContact',
  DeleteDocument = 'DeleteDocument',
  GeneratePresignedPutUrl = 'GeneratePresignedPutUrl',
  GeneratePresignedGetUrl = 'GeneratePresignedGetUrl',
  GetActionTypes = 'GetActionTypes',
  GetAgent = 'GetAgent',
  GetAgentTool = 'GetAgentTool',
  GetFunctionTypes = 'GetFunctionTypes',
  GetPublishedAgent = 'GetPublishedAgent',
  GetVoice = 'GetVoice',
  ListAgentContacts = 'ListAgentContacts',
  ListAgentTools = 'ListAgentTools',
  ListAgents = 'ListAgents',
  ListContactMessages = 'ListContactMessages',
  ListDocuments = 'ListDocuments',
  ListPhoneNumbers = 'ListPhoneNumbers',
  ListVoices = 'ListVoices',
  ManageAgent = 'ManageAgent',
  PublishAgent = 'PublishAgent',
  SendMessage = 'SendMessage',
  UpdateAgentTools = 'UpdateAgentTools',
  UploadDocument = 'UploadDocument',
}
